module.exports = __webpack_public_path__ + "img/rectangle-vertical-history.dc467d.svg";